import { PDF_STYLES } from './pdfStyles';

/**
 * Adds header and footer to each page of the PDF document.
 * @param {*} doc The jsPDF document instance
 * @param {*} fileName  The name of the file being exported
 * @param {*} options  Additional options, e.g., companyName
 */
export function addHeaderFooterToDoc(doc, fileName, options) {
    const addHeaderFooter = () => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const currentPage = doc.internal.getNumberOfPages();

        let topLeftPrimaryText = fileName;
        let companyName = options && options.companyName ? options.companyName : '';

        doc.setFontSize(PDF_STYLES.headerFontSize);
        doc.text(topLeftPrimaryText, 24, 20, { align: 'left' });
        doc.text(companyName, pageWidth - 24, 20, { align: 'right' });


        doc.setFontSize(PDF_STYLES.footerFontSize);
        doc.text(`Report Date ${new Date().toShortDateString()} ${new Date().toShortTimeString()}`, pageWidth - 24, 30, { align: 'right' });


        // Separator line above the footer text row — solid, so it reads distinct from the
        // dotted body-row dividers drawn elsewhere.
        doc.setDrawColor('#000');
        doc.setLineWidth(PDF_STYLES.detailRowDividerWidth);
        doc.setLineCap('butt');
        doc.setLineDashPattern([], 0);
        doc.line(24, pageHeight - 30, pageWidth - 24, pageHeight - 30);

        doc.setFontSize(PDF_STYLES.footerFontSize);
        doc.text(`Powered by GCORPcx`, pageWidth / 2, pageHeight - 16, { align: 'center' });
        doc.text(`Page ${currentPage}`, pageWidth - 24, pageHeight - 16, { align: 'right' });
    };


    // call once for first page
    addHeaderFooter();


    // subscribe to addPage to redraw header/footer for new pages
    doc.internal.events.subscribe('addPage', () => {
        addHeaderFooter();
    });
}